/**
 * Czy renderujemy zredesignowane UI.
 *
 * Od 2026-08-29 v2 jest DOMYSLNE — flaga zmienila biegunowosc z „wlacz" na
 * „wylacz". Wczesniej bylo `VITE_UI_V2 === 'true' || isTester`, czyli redesign
 * widzieli tylko testerzy; teraz widza go wszyscy, a `VITE_UI_V2=false` zostaje
 * jako wyjscie awaryjne do porownan i rollbacku (decyzja D9: przez caly czas
 * obie wersje musza dac sie uruchomic obok siebie).
 *
 * Rola `tester` znika z tego warunku celowo: skoro v2 jest dla wszystkich, nie
 * ma juz czego przedpremierowo odslaniac, a zostawienie roli w warunku
 * oznaczaloby, ze tester NIE MOZE zobaczyc v1 nawet przy jawnym
 * `VITE_UI_V2=false` — czyli wyjscie awaryjne nie dzialaloby akurat dla tych,
 * ktorzy najczesciej porownuja obie wersje.
 *
 * Brak zmiennej (typowy `.env.local` bez wpisu) znaczy v2 — inaczej domyslnosc
 * zalezalaby od tego, czy ktos zaktualizowal swoj plik srodowiska.
 */
export function useUiV2(): boolean {
  return import.meta.env.VITE_UI_V2 !== 'false'
}
